import { getCookie, CookiesState, COOKIES_STATE_KEY } from '.';
import debugLog from '~/shared/utils/debugLog';

export const getState = (): CookiesState | null => {
    const cookie = getCookie(COOKIES_STATE_KEY);
    if (cookie?.length) {
        try {
            return JSON.parse(cookie) || null;
        } catch (e) {
            debugLog(e, 'error');
            return null;
        }
    }
    return null;
};
